import React from 'react';
import './styles.scss';

const HorizontalLine = () => {
  return <div className="bp6-divider h-line" />;
};

export default HorizontalLine;
